import { render } from "./NavBar.vue?vue&type=template&id=659c52c8"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"
script.render = render

export default script